<div class="modal-body content width-400 height-500">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">{{ data.isCancelOnly ? 'Vorgang stornieren' : 'Statusänderung Vorgang' }}</h5>
    <div class="content">
      <exg-select [(ngModel)]="selectedIndex" class="span-3" [list]="this.data.enums" listdisplay="enmText" [caption]="'Neuer Status'" name="VorgangStatus"></exg-select>
      <exg-textarea [required]="textAreaRequired" [maxlength]="1024" [(ngModel)]="stateChangeComment" caption="Kommentar zur Statusänderung" name="stateChangeComment"></exg-textarea>
    </div>
    <div class="spawn-modal-actions">
      <button class="md-btn" (click)="clickedSave()">
        {{ data.isCancelOnly ? 'Stornieren' : getGlobal('Save')}}</button>
      <button class="md-btn" (click)="clickedCancel()">{{getGlobal('Cancel')}}</button>
    </div>
  </div>
</div>
